(function () {
  'use strict';

  function getText(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function initBar(bar) {
    if (bar.dataset.mihAnnInit === '1') return;
    bar.dataset.mihAnnInit = '1';

    bar.querySelectorAll('[data-mih-ann-item]').forEach(function (el) {
      if (!getText(el)) el.remove();
    });

    var items = bar.querySelectorAll('[data-mih-ann-item]');
    if (items.length < 2) {
      if (items.length === 1) items[0].classList.add('is-active');
      return;
    }

    var idx = 0;
    var paused = false;
    var delay = (parseInt(bar.dataset.rotate, 10) || 4) * 1000;
    var timer = null;
    var hoverRoot = bar.closest('.mih-announce-section') || bar;

    function show(nextIdx) {
      idx = nextIdx;
      items.forEach(function (el, n) {
        el.classList.toggle('is-active', n === idx);
        el.style.opacity = '';
      });
    }

    function next() {
      show((idx + 1) % items.length);
    }

    function prev() {
      show((idx - 1 + items.length) % items.length);
    }

    function start() {
      stop();
      if (paused) return;
      timer = setInterval(next, delay);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function pause() {
      paused = true;
      stop();
    }

    function resume() {
      paused = false;
      start();
    }

    show(0);
    start();

    bar.querySelector('[data-mih-ann-prev]')?.addEventListener('click', function () {
      prev();
      start();
    });

    bar.querySelector('[data-mih-ann-next]')?.addEventListener('click', function () {
      next();
      start();
    });

    hoverRoot.addEventListener('pointerenter', pause);
    hoverRoot.addEventListener('pointerleave', resume);
    hoverRoot.addEventListener('mouseenter', pause);
    hoverRoot.addEventListener('mouseleave', resume);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });
  }

  function init() {
    document.querySelectorAll('[data-mih-announce]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
